import React, { useRef, useEffect } from "react";
import "./UnstyledModal.css";
import { useClickAwayListener } from "../../../hook/ui/common/clickAwayListener/useClickAwayListener";
import { useClassPrepend } from "../../../hook/ui/common/className/useClassPrepend";

/*

    props
        (string,optional)    classPrepend      The base name of all classes, to make styling specific to an implementation. Default value is "unstyled".
        (string,optional)    title             The title of the modal. Default value is an empty string.
        (boolean,optional)   isOpen            If true, the modal is displayed. If false or undefined, nothing is rendered.
        (function)           close             The function to call when the modal should be closed.
        (boolean,optional)   clickAwayListener If true, the modal can be closed by clicking outside. Default value is false.
        (any)                children          The content to be displayed within the modal.

*/

const UnstyledModal = ({
  classPrepend = "unstyled",
  className = "",
  title = "",
  modalIsOpen,
  close,
  clickAwayListener = false,
  children
}) => {
  const [getClassName, getClassNameWithGlobal] = useClassPrepend(classPrepend);
  const modalRef = useRef(null);
  const ref = useClickAwayListener(close);
  useEffect(() => {
    if (modalIsOpen) {
      // Focus the modal when it is open for accessibility
      modalRef.current?.focus();
    }
  }, [modalIsOpen]);
  if (!modalIsOpen) {
    return null; // Do not render anything if modal is not open
  }

  if (!clickAwayListener) {
    return /*#__PURE__*/React.createElement("div", {
      className: `${classPrepend}-modal-overlay`,
      tabIndex: modalIsOpen ? 0 : -1,
      role: "dialog",
      "aria-modal": modalIsOpen ? "true" : "false"
    }, /*#__PURE__*/React.createElement("div", {
      className: `${classPrepend}-modal-content`,
      ref: modalRef
    }, /*#__PURE__*/React.createElement("h3", {
      className: `${classPrepend}-modal-title`
    }, title), /*#__PURE__*/React.createElement("div", {
      className: `${classPrepend}-modal-body`
    }, children)));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${classPrepend}-modal-container ${className}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `${classPrepend}-modal-overlay`,
    tabIndex: 0,
    role: "dialog",
    "aria-modal": modalIsOpen ? "true" : "false"
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: `${classPrepend}-modal-content`,
    ref: modalRef
  }, /*#__PURE__*/React.createElement("h3", {
    className: `${classPrepend}-modal-title`
  }, title), /*#__PURE__*/React.createElement("div", {
    className: `${classPrepend}-modal-body`
  }, children)))));
};
export { UnstyledModal };